<template>
    <div class="message-body" style="font-weight:bold">
      <p><span class="message-label" style="color:#333;" >入力期間</span><span style="color:#333;">{{ getDateFormat(item.inputStartDate) + '～' + getDateFormat(item.inputEndDate) }}</span></p>
      <p v-show="item.importantRecruteStartDate!=null">
        <span style="color:#f05b41;" class="message-label">重点募集期間</span>
        <span style="color:#f05b41;">{{ getDateFormat(item.importantRecruteStartDate) + '～' + getDateFormat(item.importantRecruteEndDate)}}</span>
      </p>
      <p v-show="item.message!=null">
        <span class="message-content" style="color:#333;">{{ item.message }}</span>
      </p>
    </div>
</template>

<script>

import moment from 'moment'

export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  methods:{
    getDateFormat(date){
      return moment(date).format("YYYY/MM/DD")
    }
  }
}
</script>